import {stockService} from '../../services/service-factory';

export default {
  data: function() {
    return {
      stockService: undefined
    };
  },
  created: function() {
    this.stockService = stockService;
  }
};
